module.exports = __webpack_public_path__ + "assets/img/btn-view-2f52aad2.png";